<template>
  <div style="height:100%;">
    <el-row style="height:55px;">
      <SearchFilter :filter="filterOptions" @handleSearch="SearchWithFilter"></SearchFilter>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px);">
      <el-table :data="data" border style="width: 100%" height="100%">
        <!-- <el-table-column prop="id" label="id" :width="120">
      </el-table-column> -->
        <el-table-column prop="task_type" label="任务类型" :width="120">
        </el-table-column>
        <el-table-column prop="task_id" label="任务号" :width="120">
        </el-table-column>
        <el-table-column prop="device_lgid" label="执行设备">
        </el-table-column>
        <el-table-column prop="start_time" label="执行时间">
        </el-table-column>
        <el-table-column prop="finish_time" label="完成时间">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showTaskDetail(scope.$index)">任务详情</el-button>
            <el-button type="text" size="small" @click="showTaskResult(scope.$index)">执行结果</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="height:42px;padding-top:10px;">
      <Pagination ref="taskPagination" totalCountOrURL="/task/cnt_taskRdAll" :params="queryParams" @change="handlePageChange"></Pagination>
    </el-row>

    <el-dialog style="padding:0;" title="任务详情" :visible.sync="taskVisible" :close-on-click-modal='false' width="570px">
      <PeriodTaskDetail ref="periodTaskDetail" v-if="task_type=='周期任务'" :period-task-id="task_id"></PeriodTaskDetail>
      <RealtimeTaskDetail ref="realtimeTaskDetail" v-if="task_type=='即时任务'" :realtimeTaskId="task_id"></RealtimeTaskDetail>
    </el-dialog>
    <el-dialog style="padding:0;" title="执行结果" :visible.sync="taskResultVisible" :close-on-click-modal='false' width="1000px">
      <TaskResult v-if="task_result_type=='record'" ref="taskResult" :task_record_id="task_record_id"></TaskResult>
      <el-form v-else-if="task_result_type=='scan'">
        <el-form-item label="扫台频率">
          <div v-if="scan_result && scan_result.length>0">
            <el-tag style="margin-right:5px;" v-for="(value,key) in scan_result" :key="key" type="success">
              {{value}}
            </el-tag>
          </div>
          <el-tag v-else>无数据</el-tag>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  import SearchFilter from "@/components/Input/SearchFilter";
  import PeriodTaskDetail from "@/components/Form/PeriodTaskDetail";
  import RealtimeTaskDetail from "@/components/Form/RealtimeTaskDetail";
  import TaskResult from "@/components/Tables/TaskResult";
  export default {
    components: {
      Pagination,
      SearchFilter,
      PeriodTaskDetail,
      RealtimeTaskDetail,
      TaskResult
    },
    mounted() {
      this.getData();
    },
    data() {
      return {
        data: [],
        queryParams: {
          orderby: {
            start_time: "DESC"
          },
          page: 1,
          size: 10
        },
        filterOptions: {
          task_type: {
            type: "select",
            text: "任务类型",
            width: "120px",
            placeholder: "请选择",
            options: ["周期任务", "即时任务"]
          },
          task_id: {
            type: "int",
            text: "任务号",
            width: "120px",
            placeholder: "请输入任务号",
          },
          start_time: {
            type: "datetimerange",
            text: "执行时间",
            width: "400px"
          }
        },
        taskVisible: false,
        task_type: "",
        task_id: 0,
        taskResultVisible: false,
        task_record_id: 0,
        task_result_type: 'record',
        scan_result: null
      };
    },
    methods: {
      SearchWithFilter(filter) {
        let options = [];
        if (filter.task_type && filter.task_type != "") {
          options.push({
            type: "1",
            name: "task_type",
            value: `'${filter.task_type}'`
          });
        }
        if (filter.task_id && filter.task_id != "") {
          options.push({
            type: "1",
            name: "task_id",
            value: filter.task_id
          });
        }
        if (filter.start_time && filter.start_time.length > 0) {
          options.push({
            type: "4",
            name: "start_time",
            value: [`'${filter.start_time[0]}'`, `'${filter.start_time[1]}'`]
          });
        }
        this.queryParams.options = options;
        this.queryParams.operator = " AND ";
        // 初始化页码
        this.queryParams.page = 1;
        // 更新导航条参数
        this.$refs["taskPagination"].getTotalsize();
        this.getData();
      },
      showTaskDetail(dataIndex) {
        this.taskVisible = true;
        this.task_type = this.data[dataIndex].task_type;
        this.task_id = this.data[dataIndex].task_id;
      },
      showTaskResult(dataIndex) {
        console.log(dataIndex)
        this.taskResultVisible = true;
        if (this.data[dataIndex].task_type == '即时任务') {
          this.$getJSON("/task/s_PeriodTaskType", {
            task_id: this.data[dataIndex].task_id
          }).then(res => {
            if (res.data[0].command == '扫台') {
              this.task_result_type = "scan";
              this.scan_result = this.data[dataIndex].scan_result;
            } else {
              this.task_result_type = "record";
              this.task_record_id = this.data[dataIndex].id;
            }
          });
        } else {
          this.task_record_id = this.data[dataIndex].id;
        }
      },
      handlePageChange(params) {
        this.queryParams.page = params.page;
        this.queryParams.size = params.size;
        this.getData();
      },
      getData() {
        this.$getJSON("/task/s_taskRdAll", this.queryParams).then(res => {
          this.data = res.data;
        });
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/TaskRdAll.vue